export function TrainingFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/training-filled.svg'"></ng-include>`
    }
}